<template lang="pug">
ContainerComponent.pb-3(
  v-if="backgroundLoaded" 
  header-text="Ferramentas" 
  subtitle-text="Acesso rápido a todas as suas funcionalidades." 
  :style="[savedImgBackgroundHome ? { backgroundImage:`url(${savedImgBackgroundHome})`, backgroundSize: 'cover' } : {}]"
)
  v-row(style="margin-top: 25px")
    v-col(cols=12 )
      v-row.d-flex.justify-center
        template(v-if="functionsLoaded")
          v-col(v-for="index in defaultFunctionsQtd" :key="index" :cols="getQuickAccessCols")
            v-skeleton-loader(type="card" :height="getHeight" :width="getWidth" light)
        template(v-else)
          v-col(v-for="item in quickAccessFunctions" :key="item.name" :cols="getQuickAccessCols")
            QuickAcessItem(:item="item" title="title")
  v-row.pt-8(no-gutters)
    v-col(cols=12)
      v-row.pb-8
        v-col
          v-divider
      template(v-if="isMobile")
        v-row.pb-10(align="center" justify="center")
          v-col(cols="auto")
            span.footer-text Versão {{ version }}
      template(v-else)    
        v-row(align="center" justify="center")  
            v-col.d-flex.flex-row.justify-end
              span.footer-text Versão {{ version }}
</template>

<script>
import QuickAcessItem from "@/components/util/QuickAcessItem.vue";
import { mapFields } from "vuex-map-fields";
import ContainerComponent from "@/components/heading/ContainerComponent.vue";
export default {
  name: "HomeFunctions",
  components: {
    QuickAcessItem,
    ContainerComponent,
  },
  data() {
    return {
      defaultFunctionsQtd: 4,
    };
  },
  computed: {
    ...mapFields("assets", ["savedImgBackgroundHome", "backgroundLoaded"]),
    version() {
      return process.env.PACKAGE_VERSION;
    },
    ...mapFields("functions", ["quickAccessFunctions", "functionsLoaded"]),
    getHeight() {
      return this.isMobile ? "150px" : "400px";
    },
    getWidth() {
      return this.isMobile ? "100%" : "306px";
    },
    getQuickAccessCols() {
      return this.isMobile ? "6" : "auto";
    },
  },
};
</script>

<style lang="sass" scoped>
.functions-container
  margin: 0
  padding: 0
  height: 100%
  width: 100%

.footer-text
  color: var(--v-homeFooterText-base)

@media #{map-get($display-breakpoints, 'xs-only')}
  .wrap-container
    margin: 0
    padding-left: 30px
    padding-right: 30px
    padding-top: 30px
    padding-bottom: 80px
    align-items: start
</style>
